export const algoExplorerUrl = process.env.NEXT_PUBLIC_EXPLORER_URL || 'https://algoexplorer.io/'

export const launchTimerStart =
  process.env.NEXT_PUBLIC_LAUNCH_TIMER_START || '2020-01-01T00:00:00.000Z'
export const launchTimerEnd = process.env.NEXT_PUBLIC_LAUNCH_TIMER_END || '2020-01-01T00:00:00.000Z'

export const API_BASE_URL = process.env.NEXT_PUBLIC_API

export const CLIENT_BASE_URL = process.env.NEXT_PUBLIC_BASE_URL

export const launchTimerEnabled = process.env.NEXT_PUBLIC_VERCEL_ENV === 'mainnet'
export const bypassKey = process.env.NEXT_PUBLIC_BYPASS_KEY

export const TREASURY_ACCT = 'RSV2YCHXA7MWGFTX3WYI7TVGAS5W5XH5M7ZQVXPPRQ7DNTNW36OW2TRR6I'
